import { Paper, styled } from '@mui/material';
import { NavLink, Route, Routes, Navigate } from 'react-router-dom';
import styles from './LandingRoutes.module.css';
import config from './config.json';
import { Alert, Header, SubHeader, useUserContext, variables } from './common';
import { Landing } from './Landing';
import { ViewUser } from './user-information';
import {
  IdentityProofingFailure,
  useIdExpiration,
  useIdle,
  useRefreshToken,
  useRefreshTokenReminder,
  useSignout,
} from './login';
import { Team } from './team';
import { Admin, Di } from './admin';
import { HelpDesk } from './help-desk';
import { QAList, useQa } from './qa';

export function LandingRoutes() {
  const { lastUserActionTime } = useIdle();
  const { refreshTokenStatus, refreshToken } = useRefreshToken();
  useRefreshTokenReminder({ lastUserActionTime, refreshToken });

  useSignout({ refreshTokenStatus });

  useIdExpiration();

  const { user } = useUserContext();

  const { qa, qaApiStatus } = useQa();

  return (
    <>
      <Paper className={styles.wrapper}>
        <Header loading={false} user={user} />
        {user.isAuthenticated ? (
          <>
            <SubHeader />

            <Mai id="main">
              <Routes>
                <Route
                  path="/my-information"
                  element={<ViewUser user={user} tabNumber={0} />}
                />
                <Route path="/my-team" element={<Team />} />
                <Route path="/admin" element={<Admin user={user} />} />
                <Route path="/di" element={<Di user={user} />} />
                <Route path="/help-desk" element={<HelpDesk user={user} />} />
                <Route path="/rps" element={<HelpDesk user={user} rpsPage={true}/>} />
                <Route path="/operations" element={<HelpDesk user={user} operationsPage={true}/>} />
                <Route path="/*" element={<Navigate to="/my-information" />} />
              </Routes>
            </Mai>
          </>
        ) : (
          <>
            <Nav>
              <NavLin to={`/`}>Home</NavLin>
              <NavLin to={`${import.meta.env.VITE_FAQ_URL}`}>
                Frequently Asked Questions
              </NavLin>
            </Nav>
            <Mai id="main">
              <Routes>
                <Route
                  index
                  element={<Landing refreshTokenStatus={refreshTokenStatus} />}
                />
                <Route
                  path="faqs"
                  element={<QAList qaApiStatus={qaApiStatus} items={qa} />}
                />
                <Route
                  path="identity-proofing-failure"
                  element={<IdentityProofingFailure />}
                />
                <Route
                  path="/*"
                  element={<h1 className="text-align-center"> </h1>}
                />
              </Routes>
            </Mai>
          </>
        )}

        <footer>{config.version}</footer>
      </Paper>
      <Alert />
    </>
  );
}

const NavLin = styled(NavLink)(({ theme }) => ({
  color: variables.brandCBP,
  // margin: '1rem',
  fontSize: '1.6rem',
  fontWeight: 500,

  textDecoration: 'none',

  // variables.link
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  '&:active, &:hover': variables.activeLink,
}));

const Nav = styled('nav')(({ theme }) => ({
  padding: '1.8rem',

  '& > * + *': {
    marginLeft: '2em',
  },
}));

const Mai = styled('main')(({ theme }) => ({
  padding: '0.5rem',
  marginBottom: 'auto',

  '@media (min-width: 40em)': {
    padding: '1.6rem',
  },
}));
